webpackJsonp([1],Array(39).concat([
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_homepage__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_about__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_about__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_portfolio__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_portfolio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_portfolio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_portfolio_item__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_portfolio_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_portfolio_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_contact__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_contact__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Homepage',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_homepage___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_about___default.a
  }, {
    path: '/portfolio',
    name: 'Portfolio',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_portfolio___default.a
  }, {
    path: '/portfolio/:slug',
    name: 'PortfolioItem',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_portfolio_item___default.a,
    props: true
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_contact___default.a
  }]
}));

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    options: {
      'filter': null,
      'toggleCompleted': 'Hide completed'
    },
    focus: {
      index: null,
      title: 'Vue Todo',
      items: []
    },
    portfolio: {
      items: {
        minibarnquilts: {
          title: 'Mini Barn Quilts',
          url: 'portfolio/minibarnquilts',
          thumbnail: '/static/images/portfolio/thumb/minibarnquilts.png',
          tags: ['Shopify', 'ECommerce', 'Marketing']
        },
        quiltalong: {
          title: 'QuiltAlong.net',
          url: 'portfolio/quiltalong',
          thumbnail: '/static/images/portfolio/thumb/quiltalong.png',
          tags: ['CMS', 'Amazon S3', 'Directory']
        },
        iappguide: {
          title: 'iAppGuide.com',
          url: 'portfolio/iappguide',
          thumbnail: '/static/images/portfolio/thumb/iappguide.png',
          tags: ['3rd Party APIs', 'Affiliate Marketing', 'Twitter Automation', 'Code Igniter']
        },
        ivesgroup: {
          title: 'IVES Group',
          url: 'portfolio/ives',
          thumbnail: '/static/images/portfolio/thumb/ivesgroup.png',
          tags: ['Bootstrap']
        },
        goby: {
          title: 'goby.com',
          url: 'portfolio/goby',
          thumbnail: '/static/images/portfolio/thumb/goby.png',
          tags: ['PHP', 'OpenX', 'Varnish', 'Memcached', 'Jenkins CI']
        },
        scout: {
          title: 'Scout.me',
          url: 'portfolio/scout',
          thumbnail: '/static/images/portfolio/thumb/scout.png',
          tags: ['Backbone', 'PHP', 'Varnish', 'Memcached', 'Grunt', 'SASS']
        },
        portfolio: {
          title: 'My Portfolio',
          url: 'portfolio/portfolio',
          thumbnail: '/static/images/portfolio/thumb/portfolio.png',
          tags: ['Vue.js', 'ES6']
        },
        simplypinterest: {
          title: 'Simply Pinterest',
          url: 'portfolio/simplypinterest',
          thumbnail: '/static/images/portfolio/thumb/simplypinterest.png',
          tags: ['WordPress Plugin', 'Social Media Marketing', 'JavaScript']
        }
      }
    }
  },

  mutations: {},

  actions: {}
});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(106),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Vuex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_js__ = __webpack_require__(40);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_Vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_Vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_4__store_js__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__app___default.a },
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__app___default.a);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cover_photos_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cover_photos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_cover_photos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footer_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'cover-photos': __WEBPACK_IMPORTED_MODULE_0__components_cover_photos_vue___default.a,
    'header-here': __WEBPACK_IMPORTED_MODULE_1__components_header_vue___default.a,
    'footer-here': __WEBPACK_IMPORTED_MODULE_2__components_footer_vue___default.a
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cover-photos',
  data: function data() {
    return {
      msg: 'Welcome to Your *New* Vue.js App'
    };
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  components: {},
  created: function created() {},

  computed: {
    item_list: function item_list() {
      var arr = [this.$store.state.portfolio.items.minibarnquilts];
      return arr;
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  components: {}
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'homepage',
  components: {}
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'portfolio-item',
  components: {},
  props: ['slug'],
  created: function created() {
    this.slug = this.$route.params.slug;
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.item_collection[this.slug]) === 'object') {
      var item = this.item_collection[this.slug];
      this.title = item.title;
      this.skills = item.skills;
      this.client = item.client;
      this.photos = item.photos;
      this.description = item.description;
    }
  },

  computed: {
    item_collection: function item_collection() {
      return this.$store.state.portfolio.items;
    }
  },
  watch: {
    $route: function $route(newRoute, oldRoute) {
      this.text = 'ERROR 404, sorry no portfolio item found!';
      this.note = '';
      this.disabled = 'disabled';

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.lists[this.slug]) === 'object') {
        var item = this.lists[this.listID].items[this.itemID];
        this.text = item.text;
        this.note = item.note;
        this.disabled = null;
      }
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'portfolio',
  components: {},
  created: function created() {},

  computed: {
    item_collection: function item_collection() {
      return this.$store.state.portfolio.items;
    }
  }
});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-media.03ff4b4.png";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-media@2x.15679d5.png";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/minibarnquilts.0ff6256.png";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(107),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cd9afbb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(108),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e8338ff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(110),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(112),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(111),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(104),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(109),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(105),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "container-fluid page-section clearfix",
    attrs: {
      "id": "section-home"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "line topmargin-sm bottommargin-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "row clearfix",
    attrs: {
      "id": "section-employment"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Freelance")]), _vm._v(" "), _c('p', [_vm._v("I take on very limited freelance opportunities but if you have an interesting project or problem that you need solved for your business please do get in touch. Quotes are customized based on a project’s needs assessment survey is completed. "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact me")]), _vm._v(" to get the conversation started.")], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line topmargin-lg bottommargin-lg"
  }), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-headline bottommargin"
  }, [_c('h1', [_vm._v("Hi I'm Terri Swallow"), _c('br'), _vm._v("Web Developer.")]), _vm._v(" "), _c('span', [_vm._v("Building websites since 2000. I specialize in creative problem solving; combining over a decade of front and backend web development experience with a dash of marketing, a tablespoon of social media, a hint of common sense and user empathy and a whole lot of passion.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Recruiters & Employers")]), _vm._v(" "), _c('p', [_vm._v("I am currently employed full time and not actively pursuing new roles. If you have a project that you think I am a good fit for I may be interested in hearing about interesting roles and opportunities and possibly share it through my network.")]), _vm._v(" "), _c('a', {
    staticClass: "button button-dark button-black nomargin",
    attrs: {
      "href": "/static/pdf/terri-swallow-senior-webdeverloper.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Download Resume")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-section",
    attrs: {
      "id": "section-services"
    }
  }, [_c('h2', {
    staticClass: "bottommargin"
  }, [_vm._v("Freelance Services.")]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-md-6 bottommargin"
  }, [_c('div', {
    staticClass: "feature-box fbox-plain fbox-dark"
  }, [_c('div', {
    staticClass: "fbox-icon"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-et-tools"
  })])]), _vm._v(" "), _c('h3', [_vm._v("Website Development")]), _vm._v(" "), _c('p', [_vm._v("Does your online presence need an update or are you just getting started? Maybe your need a content update or want to explore moving to a different platform that makes it easier for you to update the site or integrate a blog or shopping cart.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bottommargin"
  }, [_c('div', {
    staticClass: "feature-box fbox-plain fbox-dark"
  }, [_c('div', {
    staticClass: "fbox-icon"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-et-wallet"
  })])]), _vm._v(" "), _c('h3', [_vm._v("e-Commerce")]), _vm._v(" "), _c('p', [_vm._v("Are you thinking about launching an ecommerce store, selling on Facebook or managing newsletters for your direct marketing? I have experience with easy to use platforms from Shopify, Squarespace, WordPress, Etsy and more.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-md-6 bottommargin"
  }, [_c('div', {
    staticClass: "feature-box fbox-plain fbox-dark"
  }, [_c('div', {
    staticClass: "fbox-icon"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-et-lightbulb"
  })])]), _vm._v(" "), _c('h3', [_vm._v("Consulting")]), _vm._v(" "), _c('p', [_vm._v("Do you need some brief or reoccuring 1:1 time to talk out your online marketing strategy and get some unbiased feedback? Let's find out how we can come up with a strategy for your newsletters and blogs to be easier to keep up with while making sure you're spending time on the most important thing: your business.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bottommargin"
  }, [_c('div', {
    staticClass: "feature-box fbox-plain fbox-dark"
  }, [_c('div', {
    staticClass: "fbox-icon"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-et-linegraph"
  })])]), _vm._v(" "), _c('h3', [_vm._v("Analytics")]), _vm._v(" "), _c('p', [_vm._v("Do you know if your website is working for you? Once we have the right tracking setup with your website, Facebook, social media newsletters you will get a hand crafted quarterly report about what if happening with your site and social media presence.")])])])])])
}]}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "container-fluid page-section clearfix",
    attrs: {
      "id": "section-portfolio"
    }
  }, [_c('h1', {
    staticClass: "bottommargin"
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('div', {
    staticClass: "portfolio grid-container portfolio-nomargin portfolio-full portfolio-3 portfolio-masonry mixed-masonry clearfix",
    attrs: {
      "id": "portfolio"
    }
  }, _vm._l((_vm.item_collection), function(item) {
    return _c('article', {
      staticClass: "portfolio-item pf-media pf-icons wide"
    }, [_c('div', {
      staticClass: "portfolio-image imagescale"
    }, [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": item.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "i-overlay on-hover",
      staticStyle: {
        "background": "rgba(255,255,255,0.7)"
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_c('i', {
      staticClass: "icon-line-plus"
    })])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "portfolio-desc"
    }, [_c('h3', [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _vm._l((item.tags), function(tag) {
      return _c('span', {
        staticClass: "item"
      }, [_vm._v("\n                " + _vm._s(tag) + "\n              ")])
    })], 2)])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('cover-photos'), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('header-here'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer-here')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-cover-wrapper full-screen visible-lg visible-md"
  }, [_c('div', {
    staticClass: "fslider",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "top": "0",
      "left": "0",
      "background-color": "#333"
    },
    attrs: {
      "data-speed": "3000",
      "data-pause": "5000",
      "data-animation": "fade",
      "data-arrows": "false",
      "data-pagi": "false"
    }
  }, [_c('div', {
    staticClass: "flexslider",
    staticStyle: {
      "height": "100% !important"
    }
  }, [_c('div', {
    staticClass: "slider-wrap",
    staticStyle: {
      "height": "inherit !important"
    }
  }, [_c('div', {
    staticClass: "slide full-screen force-full-screen",
    attrs: {
      "id": "slide1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide full-screen force-full-screen",
    attrs: {
      "id": "slide2"
    }
  })])])])])
}]}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "dark",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "copyrights"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._v("\n\n      Copyrights © Terri Ann Creative, LLC. 2017 | All Rights Reserved\n\n    ")])])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "container-fluid page-section clearfix",
    attrs: {
      "id": "section-about"
    }
  }, [_c('div', {
    staticClass: "page-section",
    attrs: {
      "id": "section-portfolio"
    }
  }, [_c('span', {}, [_vm._v("Portfolio Item")]), _vm._v(" "), _c('h1', {
    staticClass: "bottommargin"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "postcontent bothsidebar nobottommargin"
  }, [_c('div', {
    staticClass: "col_full portfolio-single-content"
  }, [_c('p', [_vm._v("Thank you for your interest. More about this project will be coming soon.")])])])
}]}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "nobottomborder no-sticky",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "header-wrap"
    }
  }, [_c('div', {
    staticClass: "container-fluid clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('router-link', {
    staticClass: "standard-logo",
    attrs: {
      "to": "/",
      "data-dark-logo": "./../assets/images/logo-media-dark.png"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(93),
      "alt": "Canvas Logo"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "retina-logo",
    attrs: {
      "to": "/",
      "data-dark-logo": "./../assets/images/logo-media-dark@2x.png"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(94),
      "alt": "Canvas Logo"
    }
  })])], 1), _vm._v(" "), _c('nav', {
    staticClass: "style-2",
    attrs: {
      "id": "primary-menu"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/portfolio"
    }
  }, [_vm._v("Portfolio")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "primary-menu-trigger"
    }
  }, [_c('i', {
    staticClass: "icon-reorder"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-social-set"
  }, [_c('a', {
    staticClass: "social-icon si-small si-borderless si-facebook",
    attrs: {
      "href": "https://www.facebook.com/terri.a.swallow"
    }
  }, [_c('i', {
    staticClass: "icon-facebook"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-icon si-small si-borderless si-instagram",
    attrs: {
      "href": "https://www.instagram.com/terriann/"
    }
  }, [_c('i', {
    staticClass: "icon-instagram"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-instagram"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-icon si-small si-borderless si-linkedin",
    attrs: {
      "href": "https://www.linkedin.com/in/terriannswallow/"
    }
  }, [_c('i', {
    staticClass: "icon-linkedin"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-linkedin"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-icon si-small si-borderless si-github",
    attrs: {
      "href": "https://github.com/terriann"
    }
  }, [_c('i', {
    staticClass: "icon-github"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-github"
  })])])
}]}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "page-section container-fluid clearfix",
    attrs: {
      "id": "section-contact"
    }
  }, [_c('h2', {
    staticClass: "bottommargin"
  }, [_vm._v("Get in Touch")]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', [_vm._v("Located in Central Massachusetts, USA")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "1.7"
    }
  }, [_c('p', [_vm._v("If you are interested in getting in touch for consulting sessions or projects please use the button below to get in touch.")]), _vm._v(" "), _c('div', {
    staticClass: "clear topmargin"
  }), _vm._v(" "), _c('a', {
    staticClass: "button button-3d button-xlarge button-rounded button-dirtygreen",
    attrs: {
      "href": "mailto:terri.ann.s@gmail.com"
    }
  }, [_vm._v("Email Me")])])])])])])])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "page-section container-fluid clearfix",
    attrs: {
      "id": "section-about"
    }
  }, [_c('h1', {
    staticClass: "bottommargin"
  }, [_vm._v("About Me")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "alt": "Mini Barn Quilts.com",
      "src": __webpack_require__(95)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h3', [_vm._v("Mini Barn Quilts")]), _vm._v(" "), _c('p', [_vm._v("Learn more about Mini Barn Quilts and my roles, responsibilities and successes with this project.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/portfolio/minibarnquilts",
      "role": "button"
    }
  }, [_vm._v("View Portfolio Page")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("I knew, when I was in high school, that I wanted to make things on the Internet. I studied web design and development in college and graduated with a BS in Interactive Media Design. In the days of Flash and Director I stayed focused on development with PHP, MySQL and front end flavors.")]), _vm._v(" "), _c('p', [_vm._v("Since then I’ve worked on in-house products such as BobVila.com, Chitika.com, Goby.com, Scout.me, AuditAnalytics.com. I also spent time at agencies building sites for law firms, credit unions, intranets and small businesses. My broad background from startup to ad network and financial data company to running my own small business helps me bring a wide range of skills to the projects and products I work on.")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_vm._v("Open Source Contributions")]), _vm._v(" "), _c('h4', [_vm._v("CSV to Plain Text Table")]), _vm._v(" "), _c('p', [_vm._v("Github: "), _c('a', {
    attrs: {
      "href": "https://github.com/terriann/CsvToPlainTextTable"
    }
  }, [_vm._v("terriann/CsvToPlainTextTable")]), _c('br'), _vm._v("\n            Demo: "), _c('a', {
    attrs: {
      "href": "https://terriann.github.io/CsvToPlainTextTable/"
    }
  }, [_vm._v("View demo on GitHub")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Entrepreneurial Work")]), _vm._v(" "), _c('p', [_vm._v("I 2015 I launched a physical product, Mini Barn Quilts. A under $20 wooden craft kit. Inspired by traditional quilt locks these laser cut pieces could be decorated and assembled into decorative wall hangings. I had designed, manufactured, branded, marketed and sold them through online stores (Etsy, Shopify and WooCommerce.) Shortly after launching I was asked to be part of a 1-year feature in Country Living Magazine, a Hearst Publication. I designed ten licensed project kits and each was featured in one of the 10 annual issues of Country Living.")])])
}]}

/***/ })
]),[42]);


// WEBPACK FOOTER //
// static/js/app.74b864cfe380ee177819.js